import {
  Paper,
  Stack,
  Box,
  useTheme,
  createSvgIcon,
  Button,
} from "@mui/material";

import { ReactComponent as IconRouter } from "../../../../assets/easyMaps/Router.svg";
import ElementHeader from "../../../../componentes/easyMaps/elementHeader";

export default function CardHosts(props) {
  const { host, setFocusNodeId, iconsElement } = props;
  const theme = useTheme();

  const styles = {
    line: {
      backgroundColor: "primary.main",
      height: "60px",
      width: "3px",
    },
    text: {
      marginTop: "-3px",
      fontSize: "0.8em",
      maxWidth: "190px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    card: {
      width: "100%",
      borderRadius: "5px",
      backgroundColor: theme.palette.background.paperSelectedMaps,
      boxShadow: "0px 0px 3px  #0000001a",
      border: "none",
      "&::before": {
        display: "none",
      },
    },
  };

  return (
    <Paper elevation={0} sx={styles.card}>
      <ElementHeader
        tipo={host.tipo}
        titulo={host.titulo}
        interfaces={
          Array.isArray(host?.elementConfig?.config?.hosts) &&
          host?.elementConfig.config?.hosts?.length > 0
            ? host?.elementConfig?.config?.hosts[0]?.interfaces
            : []
        }
        tags={
          Array.isArray(host?.elementConfig?.config?.hosts) &&
          host?.elementConfig?.config?.hosts?.length > 0
            ? host?.elementConfig?.config?.hosts[0]?.tags
            : []
        }
        img={
          iconsElement?.find((icon) => icon.id == host.img)?.img ||
          iconsElement?.find((icon) => icon.nome == "_roteador").img
        }
      />
    </Paper>
  );
}
